// Confirmation modal component
import React from "react";

const ConfirmationModal = ({ closeConfirmationModal, message, changing }) => {
  // used for call parent function for the save as
  const onClickOk = () => {
    closeConfirmationModal(true);
  };
  const closeModal = () => {
    closeConfirmationModal(false);
  };

  return (
    <>
      <div id="confirm-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="modal-title-custom mb-0">
              <h2 className="text-white mb-0 me-auto modal-title">Change User Status</h2>
              <div className="close-icon text-end">
                <button
                  type="button"
                  className="close"
                  aria-label="close modal"
                  data-dismiss="modal"
                  onClick={closeModal}
                >
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <div className="rotation-option" style={{ marginTop: "30px" }}>
              <div className="form-group mb-3">
                <div style={{ color: "white" }}>{message}</div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn btn-primary btn-auth" onClick={onClickOk}>
                {changing && <span className="spinner-border spinner-border-sm me-2" />}
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
